import * as React from "react";
import type { SVGProps } from "react";
const SvgSparkSunweb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#spark-sunweb_svg__a)">
      <path
        fillRule="evenodd"
        d="M14.1 7.01c.99.03 1.77.21 2.34.44.44.18 1.01.46 1.2.66.3.31.32.62.16.96-.3.63-.54 1.16-1.21 1.1-.3-.02-.56-.18-.83-.3-.41-.17-.93-.39-1.88-.43-1.26-.05-1.96.4-2 1.26-.04.97.99 1.36 2.28 1.85 1.76.66 3.95 1.49 3.84 4.32-.05 1.28-.58 2.33-1.52 3.06-.99.76-2.42 1.12-4.14 1.06-1.93-.07-2.96-.63-3.59-.98-.5-.28-.62-.72-.4-1.12.32-.61.53-1.26 1.22-1.18.28.03.55.21.82.33.43.19 1.01.44 2.19.49 1.39.05 2.21-.48 2.25-1.46.04-1.09-1.09-1.52-2.4-2.03-1.7-.66-3.82-1.47-3.71-4.13.04-1.19.55-2.19 1.46-2.89.95-.73 2.31-1.08 3.94-1.02z"
        clipRule="evenodd"
      />
      <path d="M13 6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M8.81 6.99c-.32 0-.62-.15-.82-.43L6.84 4.92a.99.99 0 0 1 .25-1.39.99.99 0 0 1 1.39.25l1.15 1.64c.32.45.21 1.08-.25 1.39-.17.12-.38.18-.57.18M6.42 10.51c-.11 0-.23-.02-.34-.06L4.2 9.77a1 1 0 0 1-.6-1.28c.19-.52.76-.78 1.28-.6l1.88.68c.52.19.79.76.6 1.28-.15.41-.53.66-.94.66" />
    </g>
    <defs>
      <clipPath id="spark-sunweb_svg__a">
        <path fill="#fff" d="M3.54 2H18v19H3.54z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSparkSunweb;
